import { createSvgIcon, ListItem, styled, Tooltip } from "@mui/material";
import moment from "moment";
import {
  AutoAwesomeRounded as AutoAwesome,
  CancelRounded as Cancel,
  CheckBox,
  ForestRounded as Forest,
  GavelRounded as Gavel,
  LocalOfferRounded as LocalOffer,
  MonetizationOnRounded as MonetizationOn,
  MoneyRounded as Money,
  TransferWithinAStationRounded as TransferWithinAStation,
  EnergySavingsLeafOutlined,
} from "@mui/icons-material";
import { CURRENCY_NAME, DATE_TIME_FORMAT, EtTransactionType } from "../../utils/constants";
import { Link as RouterLink } from "react-router-dom";
import { AppRoutes } from "../../config";
import { toReadable } from "../../utils/methods";
import { TxnHashCell } from "./Transactions/txnHashCell";
import { Text, AddressLink, CurrencyLabel } from "../../components";
import { EtTransaction } from "../../types/TokenTransaction";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import GavelIcon from "@mui/icons-material/Gavel";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import LocalPoliceOutlinedIcon from "@mui/icons-material/LocalPoliceOutlined";
import { GlobalTrustAdminMonoIcon } from "../../components/RoleIcons";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
interface LatestTransactionProps {
  transaction: EtTransaction;
}

const getEventIcon = (eventType: EtTransactionType) => {
  switch (eventType) {
    case EtTransactionType.TRANSFER:
      return <TransferWithinAStation />;
    case EtTransactionType.MINTED:
      return <AutoAwesome />;
    case EtTransactionType.BID:
      return <Gavel />;
    case EtTransactionType.LISTED:
      return <LocalOffer />;
    case EtTransactionType.AUCTION_END:
      return <MonetizationOn />;
    case EtTransactionType.CANCELLED:
      return <Cancel />;
    case EtTransactionType.REWARD_CLAIMED:
      return <Forest />;
    case EtTransactionType.UPDATED:
      return <CheckBox />;
    default:
      return <Money />;
  }
};
export const getEventName = ({ type, data }: EtTransaction) => {
  switch (type) {
    case EtTransactionType.TRUST_ROLE_GRANTED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <HealthAndSafetyOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Trust+
        </span>
      );
    case EtTransactionType.TRUST_DISMISSED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <HealthAndSafetyOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Trust Blocked
        </span>
      );
    case EtTransactionType.TRUST_FLAGGED_FOR_DISMISSAL:
      return "Trust flagged";
    case EtTransactionType.REASSIGN_LAND:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <HealthAndSafetyOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Trust Reassigned
        </span>
      );
    case EtTransactionType.LISTED_TO_OFFER:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ListAltOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Listed
        </span>
      );
    case EtTransactionType.OFFER_CANCELLED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <UnsoldIcon sx={{ mr: "4px", fontSize: "1em" }} /> Unlisted
        </span>
      );
    case EtTransactionType.OFFER_WITHDRAWN:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <CancelOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Offer withdrawn
        </span>
      );
    case EtTransactionType.OFFER_PLACED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LocalOfferOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Offer
        </span>
      );
    case EtTransactionType.TRANSFER:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <SwapHorizOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Transfer
        </span>
      );
    case EtTransactionType.MINTED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <VerifiedOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Verified
        </span>
      );
    case EtTransactionType.CANCELLED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <UnsoldIcon sx={{ mr: "4px", fontSize: "1em" }} /> Unlisted
        </span>
      );
    case EtTransactionType.BID:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <GavelIcon sx={{ mr: "4px", fontSize: "1em" }} /> Bid
        </span>
      );
    case EtTransactionType.LISTED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ListAltOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Listed
        </span>
      );
    case EtTransactionType.TRUST_ADMIN_ADDED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LocalPoliceOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Admin+
        </span>
      );
    case EtTransactionType.GLOBAL_ADMIN_ADDED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <GlobalTrustAdminMonoIcon sx={{ mr: "4px", fontSize: "1em" }} /> GTA+
        </span>
      );
    case EtTransactionType.AUCTION_END:
      if (data) {
        return (
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <HandshakeOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Sold
          </span>
        );
      } else {
        return (
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <UnsoldIcon sx={{ mr: "4px", fontSize: "1em" }} /> Unlisted
          </span>
        );
      }
    case EtTransactionType.REWARD_CLAIMED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <EnergySavingsLeafOutlined sx={{ mr: "4px", fontSize: "1em" }} /> Mint+
        </span>
      );
    case EtTransactionType.UPDATED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <VerifiedOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Verified
        </span>
      );
    case EtTransactionType.CLAIM_FUNDS:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <FundsIcon sx={{ mr: "4px", fontSize: "1em" }} /> Funds+
        </span>
      );
    case EtTransactionType.ACCEPT_OFFER:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <HandshakeOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Sold
        </span>
      );
    case EtTransactionType.GUARDIAN_UPDATE_APPROVED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <GuardianIconOutlined sx={{ mr: "4px", fontSize: "1em" }} /> Guardian Update
        </span>
      );
    case EtTransactionType.DEED_ANCHORED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <AnchoredIcon sx={{ mr: "4px", fontSize: "1em" }} /> Anchored
        </span>
      );
    case EtTransactionType.DEED_ATTESTED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <AttestedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Attested
        </span>
      );
    case EtTransactionType.SETTLEMENT_FINALISED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <FinalizedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Finalized
        </span>
      );
    case EtTransactionType.DEED_CHECK_OUTCOME:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <DeedCheckResultIcon sx={{ mr: "4px", fontSize: "1em" }} /> Result
        </span>
      );
    case EtTransactionType.DEED_CHALLENGED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ChallengedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Challenged
        </span>
      );
    case EtTransactionType.DEED_CHALLENGE_DISMISSED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ChallengeDismissedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Dismissed
        </span>
      );
    case EtTransactionType.DEED_CHALLENGE_UPHELD:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ChallengeUpheldIcon sx={{ mr: "4px", fontSize: "1em" }} /> Upheld
        </span>
      );
    case EtTransactionType.REFUND_AND_RELISTED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <RelistedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Relisted
        </span>
      );
    case EtTransactionType.VERIFICATION_FUNDS_RELEASED:
      return (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <PriceCheckOutlinedIcon sx={{ mr: "4px", fontSize: "1em" }} /> Funds
        </span>
      );
    default:
      return (type as string).replaceAll("_", " ");
  }
};

const LatestTransaction = ({ transaction }: LatestTransactionProps) => {
  const time = moment(transaction.createdAt).fromNow();

  const getAmount = () => {
    if (
      transaction?.amount ||
      transaction?.data?.amount ||
      transaction?.data?.endingPrice ||
      transaction?.data?.startingPrice
    ) {
      return (
        <Text numeric>
          {toReadable(
            transaction.amount ||
              transaction.data?.amount ||
              transaction?.data?.endingPrice ||
              transaction?.data?.startingPrice
          )}{" "}
          {CURRENCY_NAME}
        </Text>
      );
    } else if (transaction?.data?.patronReward) {
      let amount: any;
      if (transaction.data.isPatron) {
        amount = BigInt(transaction.data.patronReward);
      } else {
        amount = BigInt(transaction.data.guardianReward) + BigInt(transaction.data.referralReward);
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
          <Text numeric>
            <>
              {toReadable(amount, true, true, 1)} <CurrencyLabel />
            </>
          </Text>
        </div>
      );
    } else {
      return "";
    }
  };
  return (
    <Item alignItems="center">
      <Col sx={{ flexDirection: "column", width: "45px", alignItems: "start" }}>
        <div>Land</div>
        <StyledRouterLink to={AppRoutes.LandTransactions.path.replace(":nftId", transaction.nftId.toString())}>
          #{transaction.nftId}
        </StyledRouterLink>
      </Col>

      <Col sx={{ flexDirection: "column", width: "50px", alignItems: "center" }}>
        <div>{getEventIcon(transaction.type)}</div>
        <div style={{ fontSize: "10px", textAlign: "center" }}>{getEventName(transaction)}</div>
      </Col>

      <Col sx={{ width: "140px" }}>
        <TxnHashCell item={transaction as any} />
      </Col>

      <Col sx={{ width: "130px" }}>
        <Time>
          <Tooltip arrow placement="bottom" title={moment(transaction.createdAt).format(DATE_TIME_FORMAT + ":ss")}>
            <span>{time}</span>
          </Tooltip>
        </Time>
      </Col>

      <Col style={{ flexDirection: "column" }}>
        {transaction.from ? (
          <Address>
            <div>From:</div>
            <AddressLink type="user" address={transaction.from} links={false} copy={false} />
          </Address>
        ) : transaction.data?.guardian ? (
          <Address>
            <div>Guardian:</div>
            <AddressLink type="user" address={transaction.data.guardian} links={false} copy={false} />
          </Address>
        ) : (
          ""
        )}
        {transaction.to ? (
          <Address>
            <div>To:</div>
            <AddressLink type="user" address={transaction.to} links={false} copy={false} />
          </Address>
        ) : transaction.data?.patron ? (
          <Address>
            <div>Owner:</div>
            <AddressLink type="user" address={transaction.data.patron} links={false} copy={false} />
          </Address>
        ) : (
          ""
        )}
      </Col>

      <Col sx={{ width: "160px", fontFamily: "IBM Mono", justifyContent: "end" }}>{getAmount()}</Col>
    </Item>
  );
};

const StyledRouterLink = styled(RouterLink)`
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  color: deepskyblue;
  &:visited {
    color: deepskyblue;
  }
`;

const Item = styled(ListItem)`
  display: flex;
  background: #383838;
  border-radius: 6px;
  margin-bottom: 6px;
  height: 64px;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  min-width: max-content;
`;

const Col = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  & img {
    width: 50px;
    height: 50px;
    border-radius: 4px;
  }
  & div {
    display: flex;
    align-items: center;
  }
`;

const Address = styled("div")`
  display: flex;
  flex-direction: row;

  & > div:first-of-type {
    width: 80px;
  }
`;

const Time = styled("div")`
  font-size: 12px;
  background: #535353;
  padding: 0 6px;
  border-radius: 4px;
  color: white;
  text-align: center;
  width: auto;
  text-wrap: nowrap;
`;
const FundsIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
    <path d="M336-120q-91 0-153.5-62.5T120-336q0-38 13-74t37-65l142-171-97-194h530l-97 194 142 171q24 29 37 65t13 74q0 91-63 153.5T624-120H336Zm144-200q-33 0-56.5-23.5T400-400q0-33 23.5-56.5T480-480q33 0 56.5 23.5T560-400q0 33-23.5 56.5T480-320Zm-95-360h190l40-80H345l40 80Zm-49 480h288q57 0 96.5-39.5T760-336q0-24-8.5-46.5T728-423L581-600H380L232-424q-15 18-23.5 41t-8.5 47q0 57 39.5 96.5T336-200Z" />
  </svg>,
  "Funds"
);

const UnsoldIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
    <path d="M140-440q-25 0-42.5-17.5T80-500q0-25 17.5-42.5T140-560h240q25 0 42.5 17.5T440-500q0 25-17.5 42.5T380-440H140Zm440 0q-25 0-42.5-17.5T520-500q0-25 17.5-42.5T580-560h240q25 0 42.5 17.5T880-500q0 25-17.5 42.5T820-440H580Z" />
  </svg>,
  "Unsold"
);

export const GuardianIconOutlined = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
    <path d="M480-320q102-92 131-129.5t29-74.5q0-36-26-62t-62-26q-21 0-40.5 8.5T480-580q-12-15-31-23.5t-41-8.5q-36 0-62 26t-26 62q0 19 5 35t22 37.5q17 21.5 48.5 52.5t84.5 79Zm0 240q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z" />
  </svg>,
  "Guardian"
);

// V9.1 settlement icons — path data exported verbatim from Figma (node 3008:3739). The paths are
// already on a 24x24 grid, so they go straight into createSvgIcon's own <svg>, which supplies
// viewBox="0 0 24 24" and fill="currentColor" (the icons inherit the row's text colour / dark mode).

// deed_anchored — diagonal chain link
const AnchoredIcon = createSvgIcon(
  <path d="M7.95 21C6.58333 21 5.41667 20.5167 4.45 19.55C3.48333 18.5833 3 17.4167 3 16.05C3 15.3833 3.125 14.75 3.375 14.15C3.625 13.55 3.98333 13.0167 4.45 12.55L7.8 9.225L9.2 10.625L5.85 13.975C5.56667 14.2583 5.35417 14.5792 5.2125 14.9375C5.07083 15.2958 5 15.6667 5 16.05C5 16.8667 5.2875 17.5625 5.8625 18.1375C6.4375 18.7125 7.13333 19 7.95 19C8.33333 19 8.70833 18.9292 9.075 18.7875C9.44167 18.6458 9.76667 18.4333 10.05 18.15L13.375 14.8L14.8 16.225L11.45 19.55C10.9833 20.0167 10.45 20.375 9.85 20.625C9.25 20.875 8.61667 21 7.95 21ZM9.925 15.5L8.5 14.075L14.075 8.5L15.5 9.925L9.925 15.5ZM16.2 14.8L14.8 13.375L18.15 10.05C18.4333 9.76667 18.6417 9.45 18.775 9.1C18.9083 8.75 18.975 8.38333 18.975 8C18.975 7.16667 18.6917 6.45833 18.125 5.875C17.5583 5.29167 16.8583 5 16.025 5C15.6417 5 15.2708 5.07083 14.9125 5.2125C14.5542 5.35417 14.2333 5.56667 13.95 5.85L10.625 9.2L9.2 7.8L12.55 4.45C13.0167 3.98333 13.55 3.625 14.15 3.375C14.75 3.125 15.3833 3 16.05 3C17.4167 3 18.5792 3.48333 19.5375 4.45C20.4958 5.41667 20.975 6.59167 20.975 7.975C20.975 8.625 20.8542 9.25 20.6125 9.85C20.3708 10.45 20.0167 10.9833 19.55 11.45L16.2 14.8Z" />,
  "Anchored"
);

// deed_attested — document with a checkmark
const AttestedIcon = createSvgIcon(
  <path d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V5H4V19ZM5 17H10V15H5V17ZM14.55 15L19.5 10.05L18.075 8.625L14.55 12.175L13.125 10.75L11.725 12.175L14.55 15ZM5 13H10V11H5V13ZM5 9H10V7H5V9Z" />,
  "Attested"
);

// settlement_finalised — checkmark in a circle
const FinalizedIcon = createSvgIcon(
  <path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />,
  "Finalized"
);

// deed_check_outcome — document under a magnifying glass
const DeedCheckResultIcon = createSvgIcon(
  <path d="M4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H12L18 8V10.5C17.6833 10.3667 17.3583 10.2625 17.025 10.1875C16.6917 10.1125 16.35 10.0583 16 10.025V9H11V4H4V20H10.025C10.2917 20.4 10.5917 20.7708 10.925 21.1125C11.2583 21.4542 11.625 21.75 12.025 22H4ZM17.275 18.275C17.7583 17.7917 18 17.2 18 16.5C18 15.8 17.7583 15.2083 17.275 14.725C16.7917 14.2417 16.2 14 15.5 14C14.8 14 14.2083 14.2417 13.725 14.725C13.2417 15.2083 13 15.8 13 16.5C13 17.2 13.2417 17.7917 13.725 18.275C14.2083 18.7583 14.8 19 15.5 19C16.2 19 16.7917 18.7583 17.275 18.275ZM20.6 23L17.9 20.3C17.55 20.5333 17.1708 20.7083 16.7625 20.825C16.3542 20.9417 15.9333 21 15.5 21C14.25 21 13.1875 20.5625 12.3125 19.6875C11.4375 18.8125 11 17.75 11 16.5C11 15.25 11.4375 14.1875 12.3125 13.3125C13.1875 12.4375 14.25 12 15.5 12C16.75 12 17.8125 12.4375 18.6875 13.3125C19.5625 14.1875 20 15.25 20 16.5C20 16.9333 19.9417 17.3542 19.825 17.7625C19.7083 18.1708 19.5333 18.55 19.3 18.9L22 21.6L20.6 23Z" />,
  "Deed check result"
);

// V9.1 deed-challenge icons — path data exported verbatim from Figma (node 3008:4018), same
// 24x24 grid / currentColor treatment as the settlement icons above.

// deed_challenged — document with an exclamation mark
const ChallengedIcon = createSvgIcon(
  <path d="M6 17H11V15H6V17ZM16 17H18V15H16V17ZM6 13H11V11H6V13ZM16 13H18V7H16V13ZM6 9H11V7H6V9ZM4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V5H4V19Z" />,
  "Challenged"
);

// deed_challenge_dismissed — cross in a circle
const ChallengeDismissedIcon = createSvgIcon(
  <path d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />,
  "Challenge dismissed"
);

// deed_challenge_upheld — checkmark under a magnifying glass
const ChallengeUpheldIcon = createSvgIcon(
  <path d="M14.25 14.25C15.4167 13.0833 16 11.6667 16 10C16 8.33333 15.4167 6.91667 14.25 5.75C13.0833 4.58333 11.6667 4 10 4C8.33333 4 6.91667 4.58333 5.75 5.75C4.58333 6.91667 4 8.33333 4 10C4 11.6667 4.58333 13.0833 5.75 14.25C6.91667 15.4167 8.33333 16 10 16C11.6667 16 13.0833 15.4167 14.25 14.25ZM8.95 13.55L14.6 7.875L13.175 6.45L8.95 10.7L6.825 8.6L5.4 10L8.95 13.55ZM10 18C7.76667 18 5.875 17.225 4.325 15.675C2.775 14.125 2 12.2333 2 10C2 7.76667 2.775 5.875 4.325 4.325C5.875 2.775 7.76667 2 10 2C12.2333 2 14.125 2.775 15.675 4.325C17.225 5.875 18 7.76667 18 10C18 10.9333 17.8542 11.8125 17.5625 12.6375C17.2708 13.4625 16.8583 14.2167 16.325 14.9L22 20.6L20.6 22L14.9 16.325C14.2167 16.8583 13.4625 17.2708 12.6375 17.5625C11.8125 17.8542 10.9333 18 10 18Z" />,
  "Challenge upheld"
);

// refund_and_relisted — replay arrow in a circle
const RelistedIcon = createSvgIcon(
  <path d="M7 16H17V14H7V16ZM7 12H11V10.5H9.575C9.90833 10.1833 10.2833 9.9375 10.7 9.7625C11.1167 9.5875 11.55 9.5 12 9.5C12.7833 9.5 13.4792 9.72917 14.0875 10.1875C14.6958 10.6458 15.1167 11.25 15.35 12H16.9C16.6667 10.8333 16.0917 9.875 15.175 9.125C14.2583 8.375 13.2 8 12 8C11.35 8 10.7208 8.125 10.1125 8.375C9.50417 8.625 8.96667 8.98333 8.5 9.45V8H7V12ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />,
  "Relisted"
);

export default LatestTransaction;
